var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortByAlphaBlackZtoa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sort_by_alpha_black_18dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.918,
    height: 12.918,
    viewBox: "0 0 12.918 12.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33865",
    "data-name": "Path 33865",
    d: "M0,0H12.918V12.918H0ZM0,0H12.918V12.918H0ZM.4.4H12.515V12.515H.4Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33866",
    "data-name": "Path 33866",
    d: "M8.78,3.57H6.24L7.51,2.3ZM6.256,11.488H8.764L7.51,12.742Zm3.766-7.051L7.6,10.605h.99l.5-1.319h2.751l.5,1.319h.99L10.9,4.437ZM9.414,8.4l1.044-2.788L11.5,8.4ZM3.206,9.75H6.5v.856H1.908V9.911L5.095,5.3H1.93V4.442H6.4V5.12L3.206,9.75Z",
    transform: "translate(-0.739 -1.062)",
    fill: "#55555a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortByAlphaBlackZtoa);
export default __webpack_public_path__ + "static/media/sort_by_alpha_black_ztoa.ef5410321e55f75792d2003f99484fa6.svg";
export { ForwardRef as ReactComponent };